
window.initializeDimensionManager = function() {
  // Check if we're on a product page and metafields exist
  const metafieldsJson = document.querySelector("#metafieldsJson");
  if (!metafieldsJson) return;
  
  try {
    const metafields = JSON.parse(metafieldsJson.textContent) || {};
    const productId = metafields.id || document.querySelector('[name="id"]')?.value;
    
    // Only initialize if this is a new product
    if (productId && productId !== window.currentProductId) {
      window.currentProductId = productId;
      setDynamicDimensionLimits();
      setupEventListeners();
       calcCustomSquareFeet();
    }
  } catch (error) {
    console.error("Dimension manager initialization error:", error);
  }
};

// Set dimension limits based on current product
window.setDynamicDimensionLimits = function() {
  try {
    const metafields = JSON.parse(document.querySelector("#metafieldsJson").textContent) || {};
    
    // Get dimensions in inches (with fallbacks)
    const maxWidthInches = metafields['WidLimit'] || 180; // 15ft default
    const maxLengthInches = metafields['LenLimit'] || 240; // 20ft default
    const minsqft =  metafields['MinSqrFt'] || 24; // 24ft default
    minsqft = math.floor(minsqft / 1);

    // Convert to feet
    const maxWidthFeet = Math.floor(maxWidthInches / 12);
    const maxLengthFeet = Math.floor(maxLengthInches / 12);
    
    // Set width inputs
    document.querySelectorAll('[name="WidFeet"], [name="WidFeet2"]').forEach(input => {
      input.max = maxWidthFeet;
      input.dataset.maxInches = maxWidthInches;
      input.value = 0; // Reset value
    });
    
    // Set length inputs
    document.querySelectorAll('[name="LenFeet"]').forEach(input => {
      input.max = maxLengthFeet;
      input.dataset.maxInches = maxLengthInches;
      input.value = 0; // Reset value
    });
    
    // Update display
    const sizeDisplay = document.querySelector(".variant_CustomSizeAvail");
    if (sizeDisplay) {
      sizeDisplay.textContent = `${maxWidthFeet}' × ${maxLengthFeet}'` + 
                              (metafields['SizeLimitsNote'] ? ` (${metafields['SizeLimitsNote']})` : '');
    }
    
    // Reset calculations
    document.getElementById("SqFeetTot").value = 0;
    document.getElementById("myerror").textContent = "";
    
   
  } catch (error) {
    console.error("Error setting dimensions:", error);
  }
};
 // calcCustomSquareFeet();

// Setup all event listeners
window.setupEventListeners = function() {
  // Variant change handler
 const variantSelect = document.querySelector('[name="id"]');
  var prop2 = document.querySelector("[id=size-code]");
  var prop3 = document.querySelector("[id=cust-qty-desc]");
  
if (variantSelect) {
  variantSelect.addEventListener('change', function (e) {
   prop2.value='';
  prop3.value='';
    // Small delay to allow Shopify to update the page
    setTimeout(() => {
      // setDynamicDimensionLimits();
      calcCustomSquareFeet(); // Call calculation after variant change
    }, 100);
  });
}
  
  // Input validation
  document.querySelectorAll('[name="WidFeet"], [name="WidInches"], [name="LenFeet"], [name="LenInches"]').forEach(input => {
    input.addEventListener('change', enforceMinMax);
    input.addEventListener('keyup', enforceMinMax);
  });
};

// Input validation function
window.enforceMinMax = function(e) {
  const input = e.target;
  if (input.value === "") return;
  
  const value = parseInt(input.value);
  const min = parseInt(input.min) || 0;
  const max = parseInt(input.max) || Infinity;
  
  if (isNaN(value)) {
    input.value = min;
    return;
  }
  
  if (value < min) input.value = min;
  if (value > max) input.value = max;
};

// Initialize on all page load scenarios
document.addEventListener('DOMContentLoaded', initializeDimensionManager);
document.addEventListener('turbolinks:load', initializeDimensionManager);
document.addEventListener('pjax:complete', initializeDimensionManager);
document.addEventListener('shopify:section:load', initializeDimensionManager);

// MutationObserver for dynamic content
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      initializeDimensionManager();
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

window.calcCustomSquareFeet = function () {
   const currentButton = document.querySelector('.buy-buttons .button');
  if (!currentButton) return false;

  if(currentButton.innerHTML == 'Sold out' || currentButton.innerHTML == 'sold out'  ) return false;
   
  document.querySelectorAll(".product-custom-row__col input").forEach(el => el.classList.remove("error"));

  var elem2 = document.querySelector("[name=CalcBut]");
  var prop1 = document.querySelector("[id=size-code-description]");
  var prop2 = document.querySelector("[id=size-code]");
  var prop3 = document.querySelector("[id=cust-qty-desc]");
  var err5 = document.querySelector("[id=myerror]");

  if (!elem2) return false;
  err5.innerHTML = "";

  var variantopt1 = document.querySelector("[name=testingit]");
  var mystr = variantopt1.innerHTML;
  mystr = mystr.substr(4, 1);

  var variantopt2 = document.querySelector("[name=prodtype]");
  var mystr2 = variantopt2.innerHTML;
  

  var metafields = {};
  try {
    metafields = JSON.parse(document.querySelector("#metafieldsJson").textContent);
  } catch (error) {
    console.log(error);
  }

  var maxwidin = parseInt(document.querySelector("[id=maxwid]").value || 0) || metafields['WidLimit'];
  var maxlenin = parseInt(document.querySelector("[id=maxlen]").value || 0) || metafields['LenLimit'];
  var maxwidinr = parseInt(document.querySelector("[id=maxwidr]").value || 0) || metafields['RunWid'];
  var maxleninr = parseInt(document.querySelector("[id=maxlenr]").value || 0) || metafields['RunLen'];

  var widlistin = document.querySelector("[id=widlist]").value || metafields['WidList'] || '';
  var widlistrun = document.querySelector("[id=widlistrun]").value || metafields['WidListRun'] || '';

  var elem = document.querySelector("[name=sftotal]");
  var elem3 = document.querySelector("[name=quantity]");
  var elem4 = document.querySelector("[name=custpricetot]");
  var elem3r = document.querySelector("[name=sftotalr]");
  var elem4r = document.querySelector("[name=custpricetotr]");
  var customPriceTotal = document.querySelector("#customPriceTotal");
  var custlimitstxt = document.querySelector("[id=custsizeavail]").innerHTML;

  var inputLenFeet = parseInt(document.querySelector("[name=LenFeet]").value || 0);
  var inputLenInches = parseInt(document.querySelector("[name=LenInches]").value || 0);

  var inputWidFeet = parseInt(document.querySelector("[name=WidFeet]").value || 0);
  var inputWidInches = parseInt(document.querySelector("[name=WidInches]").value || 0);

  var inputWidFeet2 = parseInt(document.querySelector("[name=WidFeet2]").value || 0);
  var inputWidInches2 = parseInt(document.querySelector("[name=WidInches2]").value || 0);

  var inputTotalWidthInches = inputWidInches + inputWidInches2;
  var inputTotalWidthFeet = inputWidFeet + inputWidFeet2;

  var inputLenTotalInches = inputLenFeet * 12 + inputLenInches;
  var inputWidthTotalInches = inputWidFeet * 12 + inputWidInches;
  var inputWidthTotalInches2 = inputWidFeet2 * 12 + inputWidInches2;

  let myprice = document.querySelector("sale-price2").textContent;
  myprice = myprice.match(/\$\d+(?:.\d+)?/);
  if (!myprice) return false;
  myprice = parseFloat(myprice[0].replace("$", ""));

  let mymsg = "", rndsqft = 0;
  elem.value = elem3.value = elem3r.value = 0;
  elem4.value = elem4r.value = "$0";
  customPriceTotal.innerHTML = "Your Price: $0";

  const maxLenFeet = Math.floor(maxlenin / 12);
  const maxLenInches = maxlenin % 12;
  const maxWidFeet = Math.floor(maxwidin / 12);
  const maxWidInches = maxwidin % 12;

  if (inputLenFeet === 0 && inputLenInches === 0 || inputWidthTotalInches === 0 || inputWidthTotalInches2 === 0) {
    mymsg = "Invalid Or Zero Dimensions, Please Check and Then Re-Calculate";
    currentButton.disabled = true;
    currentButton.style.opacity = 0.5;
  
    if (inputLenFeet === 0 && inputLenInches === 0) addErrorBorders([2]);
    if (inputWidthTotalInches === 0) addErrorBorders([4]);
    if (inputWidthTotalInches2 === 0) addErrorBorders([6]);
  }

  if ((inputWidthTotalInches + inputWidthTotalInches2) <= maxwidinr && maxwidinr >= 0) {
    maxlenin = maxleninr;
  }

  
  let mywidlist = widlistin + "," + widlistrun;
  let widarray = mywidlist.split(",");
  let mybool = true;

  if (widarray.length > 2) {
    mybool = false;
    widarray = widarray.sort();
    widarray.forEach(item => {
      if (parseInt(item) === inputWidthTotalInches) {
        mybool = true;
      }
    });
  }

  const exceedsLength = inputLenFeet > maxLenFeet || (inputLenFeet === maxLenFeet && inputLenInches > maxLenInches);
  const exceedsWidth = inputTotalWidthFeet > maxWidFeet || (inputTotalWidthFeet === maxWidFeet && inputTotalWidthInches > maxWidInches);
  

  if (!mybool) {
    mymsg = "Width Must Be One Of These Values: " + widarray;
    rndsqft = 0;
    // currentButton.disabled = true;
    // currentButton.style.opacity = 0.5;
  } else if (exceedsLength || exceedsWidth) {
    mymsg = "Invalid Dimensions: ";
   if (exceedsLength) {
  if (inputLenFeet === maxLenFeet && inputLenInches > 0) {
    mymsg += `Length is already at the maximum of ${maxLenFeet} feet. Inches must be 0."`;
    currentButton.disabled = true;
    currentButton.style.opacity = 0.5;

  } else {
    mymsg += `Length must be <= ${maxLenFeet} feet${maxLenInches > 0 ? ` and ${maxLenInches} inches` : ""}`;
    
  }
  if (maxlenin === maxleninr) mymsg += " for Runners";
  addErrorBorders([2]);
}

if (exceedsWidth) {
  if (inputTotalWidthFeet === maxWidFeet && inputTotalWidthInches > 0) {
    mymsg += ` Width is already at the maximum of ${maxWidFeet} feet. Inches must be 0."`;
    currentButton.disabled = true;
    currentButton.style.opacity = 0.5;
    

  } else {
    mymsg += ` Width must be <= ${maxWidFeet} feet${maxWidInches > 0 ? ` and ${maxWidInches} inches` : ""}`;
    
  }
  addErrorBorders([4, 6]);
}
    mymsg += ". Please Re-enter and Recalculate";
  } else {
    if (mystr === "C") {
      rndsqft = ((inputWidthTotalInches + inputWidthTotalInches2) / 12);
      rndsqft *= rndsqft;
      prop1.value = `${inputTotalWidthFeet}'${inputTotalWidthInches}"`;
      prop2.value = `${String(inputTotalWidthFeet).padStart(2, "0")}${String(inputTotalWidthInches).padStart(2, "0")} / ${prop1.value}`;
      prop3.value = "Quantity Equals Total Square Footage For Custom Rugs";
    } else {
      rndsqft = (inputLenTotalInches / 12) * (inputWidthTotalInches / 12);
      const mylenft = Math.floor(inputLenTotalInches / 12);
      const mywidft = Math.floor(inputWidthTotalInches / 12);
      const mylenin = inputLenTotalInches % 12;
      const mywidin = inputWidthTotalInches % 12;

      prop1.value = `${mywidft}'${mywidin}"x${mylenft}'${mylenin}"`;
      prop2.value = `${String(mywidft).padStart(2, "0")}${String(mywidin).padStart(2, "0")}${String(mylenft).padStart(2, "0")}${String(mylenin).padStart(2, "0")} / ${prop1.value}`;
      prop3.value = "Quantity Equals Total Square Footage For Custom Rugs";
    }

    rndsqft = Math.round(rndsqft);
    elem.value = elem3.value = elem3r.value = rndsqft;
    const finalPrice = (myprice * rndsqft).toFixed(2);
    elem4.value = elem4r.value = "$" + finalPrice;
    currentButton.disabled = false;
    currentButton.style.opacity = 1;
    customPriceTotal.innerHTML = "Your Price: $" + finalPrice;
  }
  
  if (custlimitstxt.includes("Minimum") && rndsqft < 15 && mymsg === "") {
    mymsg = "Must Be At Least 15 Square Feet, Please Enter Valid Dimensions";
    rndsqft = 0;
    addErrorBorders([2, 4, 6]);
  }
  else {
    
    if (mystr2.includes("Braided") ==false && rndsqft < 24 ) {
      
      mymsg = "Must Be At Least 24 Square Feet, Please Enter Valid Dimensions";
      rndsqft = 0;
      addErrorBorders([2, 4, 6]);
      
    }
    }
  

  if (rndsqft > 0) {
  currentButton.disabled = false;
  currentButton.style.opacity = 1;
} else {
  currentButton.disabled = true;
  currentButton.style.opacity = 0.5;
}

  err5.innerHTML = rndsqft !== 0
    ? "You may now add this to your cart.  *Note: The Quantity will equal the Square footage shown above"
    : mymsg;
};

function addErrorBorders(elemNumbers) {
  var pairs = {
    '2': ['LenInches', 'LenFeet'],
    '4': ['WidInches', 'WidFeet'],
    '6': ['WidInches2', 'WidFeet2']
  };
  elemNumbers.forEach(elemNum => {
    pairs[elemNum].forEach(elemName => {
      document.querySelector(`[name=${elemName}]`).classList.add("error");
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
   var prop2 = document.querySelector("[id=size-code]");
  var prop3 = document.querySelector("[id=cust-qty-desc]");
  document.querySelectorAll('.swatch-drop-down-custom li').forEach((x) => {
    
    x.addEventListener('click', (p) => {
      let labelName = p.target.closest('li')?.getAttribute('aria-label');

      if (labelName === 'Custom') {
        calcCustomSquareFeet();
      }
      else{
        prop2.value ='';
        prop3.value ='';
      }
    });
  });
});


